import HeroCanvas from './HeroCanvas';
import HeroAnimatedTitle from './HeroAnimatedTitle';
import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [showSubtitle, setShowSubtitle] = useState(false);
  const [showButtons, setShowButtons] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setShowSubtitle(true), 1400);
    const t2 = setTimeout(() => setShowButtons(true), 1800);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  return (
    <section id="hero" className="relative w-full min-h-screen flex items-center overflow-hidden bg-background-50">
      {/* Background image */}
      <div className="absolute inset-0 opacity-[0.08]">
        <img
          src="https://readdy.ai/api/search-image?query=Extremely%20subtle%20abstract%20minimalist%20technological%20texture%20with%20barely%20visible%20soft%20geometric%20grid%20and%20micro%20patterns%20on%20a%20near%20black%20canvas%2C%20faint%20warm%20amber%20dust%20particles%20scattered%20sparsely%2C%20delicate%20gossamer%20data%20threads%2C%20almost%20imperceptible%20ethereal%20atmosphere%2C%20ultra%20minimal%20artistic%20composition%2C%20very%20dark%20background%20with%20extremely%20dim%20ambient%20highlights%2C%20nearly%20invisible%20soft%20focus%2C%20designed%20for%20text%20overlay%20without%20distraction&width=1600&height=1000&seq=hero-bg-v1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-background-50 via-transparent to-background-50 pointer-events-none"></div>
      {/* Animated Canvas Background */}
      <HeroCanvas />

      {/* Floating blur orbs - light theme */}
      <div className="absolute top-[10%] right-[5%] w-[400px] h-[400px] md:w-[500px] md:h-[500px] rounded-full bg-accent-500/6 blur-[100px] orb-float pointer-events-none z-[2]"></div>
      <div className="absolute bottom-[20%] left-[10%] w-[300px] h-[300px] md:w-[400px] md:h-[400px] rounded-full bg-primary-400/5 blur-[80px] orb-float-slow pointer-events-none z-[2]"></div>
      <div className="absolute top-[50%] left-[60%] w-[250px] h-[250px] rounded-full bg-accent-300/4 blur-[60px] orb-float-delay pointer-events-none z-[2]"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 pt-20 pb-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Animated title - character by character */}
          <HeroAnimatedTitle
            lines={[
              { text: 'Where data' },
              { text: 'decides decisions.', accentLast: true },
            ]}
            baseClass="font-heading font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-primary-800 leading-[1.08] tracking-tight"
            accentClass="text-accent-500"
            delay={300}
            stagger={45}
            lineGap={220}
          />

          {/* Subtitle - fade up after title */}
          <p
            className="mt-6 md:mt-8 text-base sm:text-lg md:text-xl text-foreground-500 max-w-xl mx-auto leading-relaxed font-light"
            style={{
              opacity: showSubtitle ? 1 : 0,
              transform: showSubtitle ? 'translateY(0)' : 'translateY(16px)',
              transition: 'opacity 600ms ease-out, transform 600ms ease-out',
            }}
          >
            We turn your data into systems that inform, predict and act.
          </p>

          {/* Buttons - fade up after subtitle */}
          <div
            className="mt-10 md:mt-12 flex flex-col sm:flex-row gap-4 justify-center items-center"
            style={{
              opacity: showButtons ? 1 : 0,
              transform: showButtons ? 'translateY(0)' : 'translateY(16px)',
              transition: 'opacity 600ms ease-out, transform 600ms ease-out',
            }}
          >
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group whitespace-nowrap inline-flex items-center justify-center px-7 py-3 rounded-full bg-secondary-200 text-foreground-800 font-semibold text-sm md:text-base hover:bg-secondary-300 hover:scale-105 transition-all duration-300 cursor-pointer cta-glow"
            >
              Start a project
              <i className="ri-arrow-right-line ml-2 text-lg cta-arrow"></i>
            </a>
          </div>
        </div>
      </div>


    </section>
  );
}